export type CarCategory = "Economy" | "Sedan" | "SUV" | "Premium" | "Van";

export type Car = {
  id: string;
  name: string;
  category: CarCategory;
  year: number;
  seats: number;
  bags: number;
  transmission: "Automatic" | "Manual";
  fuel: "Hybrid" | "Petrol" | "Diesel" | "Electric";
  pricePerDay: number;
  image: string;
  imagePosition?: string;
  badge?: string;
};

const image = (id: string) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1200&q=84`;

export const cars: Car[] = [
  {
    id: "toyota-prius",
    name: "Toyota Prius",
    category: "Economy",
    year: 2021,
    seats: 5,
    bags: 2,
    transmission: "Automatic",
    fuel: "Hybrid",
    pricePerDay: 95,
    image: image("photo-1549317661-bd32c8ce0db2"),
    badge: "Most popular",
  },
  {
    id: "hyundai-elantra",
    name: "Hyundai Elantra",
    category: "Sedan",
    year: 2022,
    seats: 5,
    bags: 3,
    transmission: "Automatic",
    fuel: "Petrol",
    pricePerDay: 125,
    image: image("photo-1619767886558-efdc259cde1a"),
  },
  {
    id: "toyota-rav4",
    name: "Toyota RAV4",
    category: "SUV",
    year: 2022,
    seats: 5,
    bags: 4,
    transmission: "Automatic",
    fuel: "Hybrid",
    pricePerDay: 165,
    image: image("photo-1519641471654-76ce0107ad1b"),
    badge: "Great for Georgia",
  },
  {
    id: "mitsubishi-outlander",
    name: "Mitsubishi Outlander",
    category: "SUV",
    year: 2021,
    seats: 7,
    bags: 4,
    transmission: "Automatic",
    fuel: "Petrol",
    pricePerDay: 180,
    image: image("photo-1533473359331-0135ef1b58bf"),
  },
  {
    id: "mercedes-e-class",
    name: "Mercedes-Benz E-Class",
    category: "Premium",
    year: 2020,
    seats: 5,
    bags: 3,
    transmission: "Automatic",
    fuel: "Petrol",
    pricePerDay: 245,
    image: image("photo-1618843479313-40f8afb4b4d8"),
    badge: "Premium",
  },
  {
    id: "ford-transit",
    name: "Ford Transit Custom",
    category: "Van",
    year: 2021,
    seats: 8,
    bags: 6,
    transmission: "Manual",
    fuel: "Diesel",
    pricePerDay: 260,
    image: image("photo-1541899481282-d53bffe3c35d"),
    imagePosition: "center 60%",
  },
];

export const categories = ["All", "Economy", "Sedan", "SUV", "Premium", "Van"] as const;
